import { cleanNextDataUrlOrPathname } from "@/modules/routing/cleanNextDataUrlOrPathname"
import { isNextDataUrlOrPathname } from "@/modules/routing/isNextDataUrlOrPathname"

import { isPrefilteredJobSearchUrlOrPathname } from "./isPrefilteredJobSearchUrlOrPathname"

export function getSlugFromUrlOrPathname(url: string): string | null {
  if (!isPrefilteredJobSearchUrlOrPathname(url)) {
    return null
  }

  let { pathname } = new URL(url, "http://localhost")

  if (isNextDataUrlOrPathname(pathname)) {
    pathname = cleanNextDataUrlOrPathname(pathname)
  }

  const [, slug] = pathname.split("/job-search/")

  return slug
}
